/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLineHeight = createReactComponent("line-height", "IconLineHeight", [
  ["path", { d: "M3 8l3 -3l3 3", key: "svg-0" }],
  ["path", { d: "M3 16l3 3l3 -3", key: "svg-1" }],
  ["path", { d: "M6 5l0 14", key: "svg-2" }],
  ["path", { d: "M13 6l7 0", key: "svg-3" }],
  ["path", { d: "M13 12l7 0", key: "svg-4" }],
  ["path", { d: "M13 18l7 0", key: "svg-5" }]
]);

export { IconLineHeight as default };
//# sourceMappingURL=IconLineHeight.js.map
